import type { FC } from 'react'
import { useState } from 'react'

import { Drawer } from '../drawer'

import { OwnerBuyAccommodation } from './OwnerBuyAccommodation'
import { OwnerBuyAccommodationDrawerMode } from './OwnerBuyAccomodationDrawerMode'
import { OwnerBuyInternationalDestination } from './OwnerBuyInternationalDestination'

interface OwnerBuyAccommodationDrawerProps {
  isOpen: boolean
  onClose: () => void
}

export const OwnerBuyAccommodationDrawer: FC<OwnerBuyAccommodationDrawerProps> = ({ isOpen, onClose }) => {
  const [mode, setMode] = useState<OwnerBuyAccommodationDrawerMode>(OwnerBuyAccommodationDrawerMode.ACCOMMODATION)

  return (
    <Drawer open={isOpen} onClose={onClose} anchor='bottom'>
      {mode === OwnerBuyAccommodationDrawerMode.ACCOMMODATION && (
        <OwnerBuyAccommodation onClose={onClose} setMode={setMode} />
      )}
      {mode === OwnerBuyAccommodationDrawerMode.INTERNATIONAL_DESTINATION && (
        <OwnerBuyInternationalDestination onClose={onClose} setMode={setMode} />
      )}
    </Drawer>
  )
}
